import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { selectDateFormat } from '../store/shared-store/selectors/shared.selector';

@Pipe({
    name: 'formatDate',
    pure: false,
    standalone: false
})
export class FormatDatePipe implements PipeTransform {

  formatValue: string = 'MM/dd/yyyy'

  constructor(
    private datePipe: DatePipe,
    private store: Store
  ) { }

  transform(value: Date | string | number, ...args: unknown[]): unknown {
    this.store.pipe(select(selectDateFormat)).subscribe((dateFormat) => {
      this.formatValue = dateFormat;
    });
    return this.datePipe.transform(value, this.formatValue)
  }

}
